// Quantidade de informações complementares por configuração de impressão.
// O iNOVAONE tem 10; o iNOVAID tem 12 (inf_compl_1..12). Com destino dos
// itens = iNOVAID as telas e a configuração passam a mostrar as 12.

import { ehDestinoInovaid } from "./destinoItens";

export const TOTAL_INFO_COMPL_PADRAO = 10;
export const TOTAL_INFO_COMPL_INOVAID = 12;
/** Maior índice aceito em qualquer destino (validação de JSON salvo). */
export const TOTAL_INFO_COMPL_MAXIMO = TOTAL_INFO_COMPL_INOVAID;

type ConfigComDestino = { destino_itens?: string } | null | undefined;

export function quantidadeInfoCompl(config: ConfigComDestino): number {
  return ehDestinoInovaid(config)
    ? TOTAL_INFO_COMPL_INOVAID
    : TOTAL_INFO_COMPL_PADRAO;
}

/** Índices 1..N das informações complementares da configuração. */
export function indicesInfoCompl(config: ConfigComDestino): number[] {
  return Array.from({ length: quantidadeInfoCompl(config) }, (_, i) => i + 1);
}

/** Rótulo da conta para a info `idx`, ou o padrão "<prefixo> idx". */
export function rotuloInfoCompl(
  contaConfig: unknown,
  idx: number,
  prefixo = "Info. Compl.",
): string {
  const rotulo = (contaConfig as Record<string, unknown> | null | undefined)?.[
    `info_compl_${idx}`
  ];
  return typeof rotulo === "string" && rotulo.trim()
    ? rotulo
    : `${prefixo} ${idx}`;
}
